import {
    publishTriggerCount,
    publishNotesDown
} from 'messaging/messages.js';

// publishes messages related to statistics of whats currently going on
// this incnlues:
// Notes down
// Density
export const stats = (sequencerEngine) => {
    let notes = new Set();
    let triggerCount = 0;
    for (let sub of sequencerEngine.subSequences) {
        for (let track of sub.tracks) {
            triggerCount += (track.triggerCount || 0);
            let _notes = Object.keys(track.notesTriggered || {});
            _notes.forEach(x => notes.add(parseFloat(x)));
        }
    }
    publishNotesDown(Array.from(notes));
    publishTriggerCount(triggerCount);
};
